export default {
  name: 'HomeView'
};